import { cn } from '@/lib/utils';

/** Kept out of `variable-pill.tsx` so the serializers can build pill HTML without pulling in React. */
export const variablePillClasses = cn(
	'variable-node',
	'inline-flex items-center',
	'mx-0.5 px-0.5 py-0',
	'rounded',
	'bg-accent-blue text-primary-blue',
	'text-sm font-medium',
	'cursor-default select-none'
);

/** Mirrors the assigned-comments mention, so form mentions read as a mention not a filled chip. */
export const variableMentionClasses = cn(
	'variable-node',
	'font-medium text-primary-blue',
	'cursor-default select-none'
);
